import React from "react";
import { Star } from "lucide-react";
import ResourceManager from "../../components/admin/ResourceManager";

const PACKAGE_FIELDS = [
    { key: "name",        label: "Package Name",   type: "text",     required: true, placeholder: "Business Pack" },
    { key: "slug",        label: "Slug",           type: "text",     required: true, placeholder: "business" },
    { key: "category",    label: "Category",       type: "select",   required: true, options: ["branding", "web"], helpText: "'branding' shows under Branding & Design; 'web' shows under Website Design." },
    { key: "price_label", label: "Price Label",    type: "text",     required: true, placeholder: "₹9,999" },
    { key: "price_sub",   label: "Price Subtitle", type: "text",     placeholder: "one-time / talk to us" },
    { key: "tagline",     label: "Tagline",        type: "text",     placeholder: "Logo + identity essentials to launch." },
    { key: "image_url",   label: "Reference Image", type: "image",   helpText: "Optional — shown on Website Design package cards." },
    { key: "features",    label: "Features",       type: "list",     required: true, rows: 6, helpText: "One feature per line." },
    { key: "highlight",   label: "Highlight Card", type: "switch",   defaultValue: false, helpText: "Highlights the card with a gold gradient." },
    { key: "badge",       label: "Badge",          type: "text",     placeholder: "Most Popular (optional)" },
    { key: "position",    label: "Position",       type: "number" },
    { key: "visible",     label: "Visibility",     type: "switch",   defaultValue: true },
];

export const AdminPackagesPage = () => (
    <ResourceManager
        resourceKey="packages"
        title="Shop Packages Manager"
        singular="Package"
        description="Edit pricing, features and visibility of design packages shown on the Shop page."
        endpoint="/admin/packages"
        fields={PACKAGE_FIELDS}
        renderItem={(item) => (
            <div>
                <div className="flex items-center gap-2 mb-1">
                    <span className="font-poppins font-medium text-white">{item.name}</span>
                    <span className="inline-flex font-inter text-[10px] uppercase tracking-[0.15em] text-zinc-400 border border-white/10 px-2 py-0.5 rounded-full">
                        {item.category === "web" ? "Website" : "Branding"}
                    </span>
                    {item.highlight && (
                        <span className="inline-flex items-center gap-1 bg-gold text-black text-[10px] uppercase tracking-[0.2em] font-medium font-inter px-2 py-0.5 rounded-full">
                            <Star size={9} fill="currentColor" strokeWidth={0} />
                            {item.badge || "Highlight"}
                        </span>
                    )}
                </div>
                <div className="font-poppins font-semibold text-gold text-lg">
                    {item.price_label}{" "}
                    <span className="font-inter text-xs uppercase tracking-[0.2em] text-zinc-500 ml-1">
                        {item.price_sub}
                    </span>
                </div>
                <p className="mt-1 font-inter text-sm text-zinc-400 line-clamp-1">{item.tagline}</p>
                <p className="mt-1 font-inter text-xs text-zinc-500">
                    {Array.isArray(item.features) ? `${item.features.length} features` : ""}
                </p>
            </div>
        )}
    />
);

export default AdminPackagesPage;
